import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "pencil" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.19,1.81a3.639,3.639,0,0,0-5.17.035l-14.5,14.5L.75,23.25l6.905-1.771,14.5-14.5A3.637,3.637,0,0,0,22.19,1.81Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.606,
			y1: 2.26,
			x2: 21.74,
			y2: 7.394
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.521,
			y1: 16.344,
			x2: 7.66,
			y2: 21.474
		})
	]
});
export default SvgPencil;
